"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factorKeys = void 0;
exports.factorKeys = ['bestExpectation', 'worstExpectation', 'growthLimit'];
//# sourceMappingURL=sharePrice.types.js.map